import React from "react";

import { Avatar, CardHeader } from "@material-ui/core";

import { i18n } from "../../translate/i18n";

const TicketInfo = ({ contact, ticket, onClick }) => {
	return (
		<div className="d-flex align-items-center cursor-pointer" onClick={onClick}>
			<div className="position-relative">
				{contact.profilePicUrl ? (
					<img
						src={contact.profilePicUrl}
						className="rounded-circle avatar-md"
						width="45"
						height="45"
						style={{ objectFit: 'cover' }}
						alt={contact.name}
					/>
				) : (
					<div className="rounded-circle avatar-md avatar-letter">
						{contact.name?.charAt(0).toUpperCase() || "?"}
					</div>
				)}
			</div>
			<div className="ms-3 overflow-hidden" style={{ maxWidth: '300px' }}>
				<h6 className="mb-0 text-truncate text-dark fw-bold">
					{contact.name} <span className="text-muted fw-normal">#{ticket.id}</span>
				</h6>
				{ticket.user && (
					<small className="text-muted d-block text-truncate">
						<i className="fi fi-rr-user-check me-1"></i>
						{i18n.t("messagesList.header.assignedTo")} {ticket.user.name}
					</small>
				)}
			</div>
		</div>
	);
};

export default TicketInfo;
